import { z } from 'zod';

export const OutdoorBarArticleIncludedServiceModelSchema = z.object({
    name: z.string(),
    description: z.any().optional().nullable(),
});

export type OutdoorBarArticleIncludedServiceModel
    = z.infer<typeof OutdoorBarArticleIncludedServiceModelSchema>;
